// extracted by mini-css-extract-plugin
module.exports = {"dmrFrame":"DmrFrame__dmrFrame--129L9"};